/* @flow */
import { ActionTypes as TransactionConstants } from '../constants/TransactionConstants';
import { ActionTypes } from '../constants/ActivityConstants';
import Activities from 'collections/Activities';
import Transactions from 'collections/Transactions';

type State = {
  activities: Activities,
  transactions: {[key: string]: Transactions},
}

export const initialState: State = {
  activities: new Activities(),
  transactions: {},
};

export type loadActivitiesSuccessAction = {
  type: 'activities/LOAD_ACTIVITIES_SUCCESS',
  activities: Activities,
};

export function loadActivitiesSuccess(activities: Activities): loadActivitiesSuccessAction {
  return {
    type: 'activities/LOAD_ACTIVITIES_SUCCESS',
    activities,
  };
}

export type ActivitiesActions =
  loadActivitiesSuccessAction;

export function reducer(state: State = initialState, action: any) {
  let activities;
  let transactions;

  switch (action.type) {
    case ActionTypes.LOAD_ACTIVITIES:
      activities = new Activities(state.activities.toJSON());
      activities.add(action.activities.models);
      return { ...state, activities };

    case ActionTypes.CREATE_ACTIVITY:
    case ActionTypes.LOAD_ACTIVITY:
    case ActionTypes.EDIT_ACTIVITY:
    case ActionTypes.CLOSE_ACTIVITY:
      activities = new Activities(state.activities.toJSON());
      activities.add(action.activity);
      return { ...state, activities };

    case TransactionConstants.CREATE_ACTIVITY_WITHDRAW_TRANSACTION: {
      const act = action.activityId;
      transactions = state.transactions;


      transactions[act] = transactions[act] ? new Transactions(transactions[act].toJSON()) : new Transactions();
      transactions[act].add(action.transaction);

      return { ...state, transactions };
    }

    case ActionTypes.GET_TRANSACTIONS:
      transactions = state.transactions;
      transactions[action.activityId] = action.transactions;
      return { ...state, transactions };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/payments/reducers/Activities.js